import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { User } from './master-visualizar-usuario.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root',
})
export class MasterVisualizarUsuarioService {
  constructor(private httpClient: HttpClient) {}

  getUserByUserId(userId?: string): Observable<any> {
    if (userId === null || userId === undefined) {
      return throwError('Required parameter userId was null or undefined.');
    }

    return this.httpClient
      .post<any>(`${BASE_PATH}/bff/users/view/`, {
        id: userId,
      })
      .pipe(retry(5), catchError(null));
  }
}
